<mat-tab-group animationDuration="0ms" (selectedTabChange)="changeTabActions($event)" [selectedIndex]="1">
  <mat-tab label="{{ 'field.customFilters' | translate }}">
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <app-custom-filters [additionalDatatableRefresh]="customFiltersTabSelect$"></app-custom-filters>
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'field.endpointParameters' | translate }}">
    <ng-template matTabContent>
      <div class="px-3 pt-3 pb-3">
        <app-endpoint-parameters [additionalDatatableRefresh]="endpointParametersTabSelect$"></app-endpoint-parameters>
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
